import { IGlobalModal } from '../directives';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalModalsService {

  private _registeredModals: {key: string; modalRef: IGlobalModal}[] = [];

  constructor(private readonly _router: Router) {}


  registerModal(key: string, modalRef: IGlobalModal) {
    this._registeredModals.push({
      key,
      modalRef
    });
  }

  openModal(key, object = null) {
    const modal = this._registeredModals.find(value => value.key === key);
    if (modal) {
      modal.modalRef.showModal(object);
    }
  }

  closeModal(key: string): void {
    const modal = this._registeredModals.find(value => value.key === key);
    modal?.modalRef.closeModal?.();
  }

  leaveMenuModalRoute(): void {
    const path = this._router.url.split('?')[0];
    const parentByPath: Record<string, string> = {
      '/stock-transfer/incoming': '/stock-transfer',
      '/stock-transfer/outgoing': '/stock-transfer',
      '/production-orders/process': '/production-orders',
      '/orders/ship': '/orders/open',
      '/slns/finder': '/slns',
    };
    const parent = parentByPath[path];
    if (parent) {
      void this._router.navigateByUrl(parent);
    }
  }
}
